export const teamsData = [
  // MLB Teams
  { name: "Arizona Diamondbacks", id: 109, abbr: "ARI", color: "#a71930", secondary: "#e3d112", league: "MLB" },
  { name: "Oakland Athletics", id: 133, abbr: "OAK", color: "#003831", secondary: "#efb21e", league: "MLB" },
  { name: "Atlanta Braves", id: 144, abbr: "ATL", color: "#ba0c2f", secondary: "#0c2340", league: "MLB" },
  { name: "Baltimore Orioles", id: 110, abbr: "BAL", color: "#df4601", secondary: "#000000", league: "MLB" },
  { name: "Boston Red Sox", id: 111, abbr: "BOS", color: "#bd3039", secondary: "#0c2340", league: "MLB" },
  { name: "Chicago Cubs", id: 112, abbr: "CHC", color: "#0e3386", secondary: "#cc3433", league: "MLB" },
  { name: "Chicago White Sox", id: 145, abbr: "CWS", color: "#27251f", secondary: "#c4ced4", league: "MLB" },
  { name: "Cincinnati Reds", id: 113, abbr: "CIN", color: "#c6011f", secondary: "#000000", league: "MLB" },
  { name: "Cleveland Guardians", id: 114, abbr: "CLE", color: "#e31937", secondary: "#00385d", league: "MLB" },
  { name: "Colorado Rockies", id: 115, abbr: "COL", color: "#333366", secondary: "#c4ced4", league: "MLB" },
  { name: "Detroit Tigers", id: 116, abbr: "DET", color: "#fa4616", secondary: "#0c2340", league: "MLB" },
  { name: "Houston Astros", id: 117, abbr: "HOU", color: "#eb6e1f", secondary: "#002d62", league: "MLB" },
  { name: "Kansas City Royals", id: 118, abbr: "KC", color: "#004687", secondary: "#bd9b60", league: "MLB" },
  { name: "Los Angeles Angels", id: 108, abbr: "LAA", color: "#ba0021", secondary: "#003263", league: "MLB" },
  { name: "Los Angeles Dodgers", id: 119, abbr: "LAD", color: "#005a9c", secondary: "#ef3e42", league: "MLB" },
  { name: "Miami Marlins", id: 146, abbr: "MIA", color: "#00a3e0", secondary: "#ef3340", league: "MLB" },
  { name: "Milwaukee Brewers", id: 158, abbr: "MIL", color: "#12284b", secondary: "#ffc52f", league: "MLB" },
  { name: "Minnesota Twins", id: 142, abbr: "MIN", color: "#d31145", secondary: "#002b5c", league: "MLB" },
  { name: "New York Mets", id: 121, abbr: "NYM", color: "#002d72", secondary: "#ff5910", league: "MLB" },
  { name: "New York Yankees", id: 147, abbr: "NYY", color: "#003087", secondary: "#c4ced4", league: "MLB" },
  { name: "Philadelphia Phillies", id: 143, abbr: "PHI", color: "#e81828", secondary: "#002d72", league: "MLB" },
  { name: "Pittsburgh Pirates", id: 134, abbr: "PIT", color: "#fdb827", secondary: "#27251f", league: "MLB" },
  { name: "San Diego Padres", id: 135, abbr: "SD", color: "#ffc425", secondary: "#2f241d", league: "MLB" },
  { name: "San Francisco Giants", id: 137, abbr: "SF", color: "#fd5a1e", secondary: "#27251f", league: "MLB" },
  { name: "Seattle Mariners", id: 136, abbr: "SEA", color: "#005c5c", secondary: "#0c2c56", league: "MLB" },
  { name: "St. Louis Cardinals", id: 138, abbr: "STL", color: "#c41e3a", secondary: "#fedb00", league: "MLB" },
  { name: "Tampa Bay Rays", id: 139, abbr: "TB", color: "#8fbce6", secondary: "#092c5c", league: "MLB" },
  { name: "Texas Rangers", id: 140, abbr: "TEX", color: "#003278", secondary: "#c0111f", league: "MLB" },
  { name: "Toronto Blue Jays", id: 141, abbr: "TOR", color: "#134a8e", secondary: "#e8291c", league: "MLB" },
  { name: "Washington Nationals", id: 120, abbr: "WSH", color: "#ab0003", secondary: "#14225a", league: "MLB" },
];

/**
 * Gets the primary color for a team by its ID, Name, or Abbreviation.
 * @param {string|number} identifier - The team ID, Name, or Abbreviation (e.g., 147, "New York Yankees", or "NYY")
 * @returns {string} The hex color code or a default fallback color.
 */
/**
 * Gets the color for a team.
 * @param {string|number} identifier - Team ID, Name, or Abbr
 * @param {boolean} useSecondary - Whether to return the secondary color
 */
export const getTeamColor = (identifier, useSecondary = false) => {
  if (!identifier) return "#333333";
  
  const team = teamsData.find(
    (t) => 
      t.id === identifier || 
      t.name === identifier || 
      t.abbr === identifier ||
      t.abbr === String(identifier).toUpperCase()
  );
  
  if (!team) return "#333333";
  return useSecondary && team.secondary ? team.secondary : team.color;
};

// Helper: Convert hex to RGB
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

// Helper: Calculate perceptual color distance
const getColorDistance = (color1, color2) => {
  const rgb1 = hexToRgb(color1);
  const rgb2 = hexToRgb(color2);
  if (!rgb1 || !rgb2) return 1000;
  
  return Math.sqrt(
    Math.pow(rgb1.r - rgb2.r, 2) +
    Math.pow(rgb1.g - rgb2.g, 2) +
    Math.pow(rgb1.b - rgb2.b, 2)
  );
};

// Helper: Calculate luminance
const getLuminance = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return 0;
  // Perceptual luminance formula
  return (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b);
};

// Helper: Lighten a color by a percentage
const lightenColor = (hex, percent) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * percent));
  const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * percent));
  const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * percent));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

/**
 * Resolves colors for a game, preventing collisions if teams have similar primary colors.
 * Also ensures colors meet a minimum luminance for dark mode visibility.
 */
export const getContrastColors = (homeAbbr, awayAbbr, isDark = true) => {
  let homeColor = getTeamColor(homeAbbr, false);
  let awayColor = getTeamColor(awayAbbr, false);
  const awaySecondary = getTeamColor(awayAbbr, true);
  
  const distance = getColorDistance(homeColor, awayColor);
  
  // If colors are too close (threshold 100), switch away team to secondary
  if (distance < 100) {
    awayColor = awaySecondary;
  }
  
  // Accessibility check for Dark Mode
  if (isDark) {
    const minLuminance = 60; // Threshold for dark background visibility
    if (getLuminance(homeColor) < minLuminance) {
      homeColor = lightenColor(homeColor, 0.4); // Lighten by 40% if too dark
    }
    if (getLuminance(awayColor) < minLuminance) {
      awayColor = lightenColor(awayColor, 0.4);
    }
  }
  
  return {
    home: homeColor,
    away: awayColor
  };
};

export default teamsData;
